import React from 'react';

import Row1_Img_1 from '../../../Images/gallery/idealz/row1_img-1.png';
import Row1_Img_2 from '../../../Images/gallery/idealz/row1_img-2.png';
import Row1_Img_3 from '../../../Images/gallery/idealz/row1_img-3.png';
import Row1_Img_4 from '../../../Images/gallery/idealz/row1_img-4.png';

import Row2_Img_1 from '../../../Images/gallery/idealz/row2_img-1.png';
import Row2_Img_2 from '../../../Images/gallery/idealz/row2_img-2.png';
import Row2_Img_3 from '../../../Images/gallery/idealz/row2_img-3.png';
import Row2_Img_4 from '../../../Images/gallery/idealz/row2_img-4.png';

import Row3_Img_1 from '../../../Images/gallery/idealz/row3_img-1.png';
import Row3_Img_2 from '../../../Images/gallery/idealz/row3_img-2.png';
import Row3_Img_3 from '../../../Images/gallery/idealz/row3_img-3.png';
import Row3_Img_4 from '../../../Images/gallery/idealz/row3_img-4.png';

import Row4_Img_1 from '../../../Images/gallery/idealz/row4_img-1.png';
import Row4_Img_2 from '../../../Images/gallery/idealz/row4_img-2.png';
import Row4_Img_3 from '../../../Images/gallery/idealz/row4_img-3.png';

export const Idealz_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>IDEALZ</span>,
  },
];

export const Title_1 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>IDEALZ LANZAMIENTO</span>,
  },
];

export const Title_2 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>IDEALZ MAKING OF</span>,
  },
];

export const Title_3 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>SHORTS</span>,
  },
];

export const Title_4 = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FOTO FIJA</span>,
  },
];

export const First_Row = [
  {
    src: Row1_Img_1,
    alt: 'image',
  },
  {
    src: Row1_Img_2,
    alt: 'image',
  },
  {
    src: Row1_Img_3,
    alt: 'image',
  },
  {
    src: Row1_Img_4,
    alt: 'image',
  },
];

export const Second_Row = [
  {
    src: Row2_Img_1,
    alt: 'image',
  },
  {
    src: Row2_Img_2,
    alt: 'image',
  },
  {
    src: Row2_Img_3,
    alt: 'image',
  },
  {
    src: Row2_Img_4,
    alt: 'image',
  },
];

export const Third_Row = [
  {
    src: Row3_Img_1,
    alt: 'image',
  },
  {
    src: Row3_Img_2,
    alt: 'image',
  },
  {
    src: Row3_Img_3,
    alt: 'image',
  },
  {
    src: Row3_Img_4,
    alt: 'image',
  },
];

export const Fourth_Row = [
  {
    src: Row4_Img_1,
    alt: 'image',
  },
  {
    src: Row4_Img_2,
    alt: 'image',
  },
  {
    src: Row4_Img_3,
    alt: 'image',
  },
];
